import HeaderMenuGroup from './_lib/HeaderMenuGroup.js';

document.addEventListener('DOMContentLoaded', () => {
  new HeaderMenuGroup(document.querySelectorAll('.l-header__nav__category'));
});
